import styles from "./Spinner.module.css";

export function Spinner() {
  return (
    <svg
      data-testid="loading-spinner"
      className={styles.spinner}
      viewBox="0 0 50 50"
    >
      <circle
        className={styles.circle}
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
      ></circle>
    </svg>
  );
}
